module.exports = __webpack_public_path__ + "ec0476805522959066b6660cec687376.png";